export enum FastInventoryModal {
  SORT_BY_INVENTORY = 'SORT_BY_INVENTORY',
  CONFIRM_SELLING = 'CONFIRM_SELLING',
}
